/// components
import Partial from './components/Partial.vue';
import RemoteModal from './components/RemoteModal.vue';

import VueProgressBar from 'vue-progressbar';
/// directives
import directive from './directives/remote-modal';

const noop = () => {};
const Placeholder = {
    render: h => h(null)
};

const defaultOptions = {
    enabled:() => typeof window.fetch === 'function'
};

export default {
    install(Vue, opt) {
        let options = {
            ...defaultOptions, ...opt
        };
        let isEnabled = options.enabled();

        Vue.use(VueProgressBar);

        Vue.component('partial', Partial);
        Vue.component('remote-modal', isEnabled ? RemoteModal : Placeholder);

        Vue.directive('remote-modal', isEnabled ? directive : noop);
    }
}
